var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-select", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      placeholder: _vm.placeholder,
      disabled: _vm.disabled
    },
    on: {
      change: _vm.onChange
    },
    model: {
      value: _vm.selectedValues,
      callback: function ($$v) {
        _vm.selectedValues = $$v;
      },
      expression: "selectedValues"
    }
  }, _vm._l(_vm.province, function (item3, index3) {
    return _c("a-select-option", {
      key: index3,
      attrs: {
        value: item3
      }
    }, [_vm._v(" " + _vm._s(item3) + " ")]);
  }), 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };